import { z } from 'zod';
import { useGenericForm } from '@/hooks/use-generic-form';
import { checkEmailSchema } from '@/validation/check-email.schema';
import { AxiosError } from 'axios';
import { useCheckEmail } from '@/api/auth/auth.hooks.ts';
import { CheckEmailResponse } from '@/api/auth/auth.types.ts';

type CheckEmailFormData = z.infer<typeof checkEmailSchema>;

export const useCheckEmailForm = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (response: CheckEmailResponse) => void;
  onError?: (error: AxiosError) => void;
}) => {
  const checkEmailMutation = useCheckEmail();

  return useGenericForm<CheckEmailFormData, CheckEmailResponse>({
    schema: checkEmailSchema,
    mutation: checkEmailMutation,
    onSuccess,
    onError,
  });
};
